'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { AnimatedButton } from '@/components/ui/animated-button';
import { EmptyState } from '@/components/ui/empty-state';
import { Clock01Icon } from '@/components/ui/icon/glyphs';
import { Link } from '@/i18n/navigation';
export function ActivityEmpty() {
  const $ = _c(12);
  const t = useTranslations("profile.next.empty.activity");
  let t0;
  if ($[0] !== t) {
    t0 = t("title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("body");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("cta");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <AnimatedButton asChild={true} variant="secondary"><Link href="/markets">{t2}</Link></AnimatedButton>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t0 || $[9] !== t1 || $[10] !== t3) {
    t4 = <EmptyState icon={Clock01Icon} title={t0} description={t1} action={t3} />;
    $[8] = t0;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}